import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorRewards = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M11.725 11.917a.29.29 0 0 1 .55 0l.584 1.716h1.85c.284 0 .4.367.165.53l-1.485 1.031.575 1.69a.29.29 0 0 1-.441.332L12 16.16l-1.523 1.057a.29.29 0 0 1-.44-.332l.574-1.69-1.486-1.031a.29.29 0 0 1 .166-.53h1.85l.584-1.716Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="m16.64 7.25-1.806-3.003a.25.25 0 0 0-.343-.086L9.355 7.25h7.285Zm-10.134 0a.75.75 0 0 1 .169-.138l7.042-4.236a1.75 1.75 0 0 1 2.402.597l2.272 3.777H19A2.75 2.75 0 0 1 21.75 10v1.67a.75.75 0 0 1-.5.708 2.251 2.251 0 0 0 0 4.244c.3.106.5.39.5.707V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-1.67c0-.319.2-.602.5-.708a2.251 2.251 0 0 0 0-4.244.75.75 0 0 1-.5-.707V10A2.75 2.75 0 0 1 5 7.25h1.506ZM3.75 10c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v1.183a3.749 3.749 0 0 0 0 6.634V19c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-1.183a3.75 3.75 0 0 0 0-6.634V10Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorRewards;
